import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { assignDataToFields } from '~/utils/strapiComponents/addStrapiData';

export const useStoreBuyCryptoModal = defineStore('buyCryptoModal', {
  state: () => ({
    title: '',
    minDepositName: '',
    minDeposit: '',
    timeProcessingName: '',
    timeProcessing: '',
    verificationName: '',
    verification: '',
    buyCryptoInfoText: '',
    paymentName: '',
    currenciesName: '',
    labelInput: '',
    amountInfoText: '',
    titleAddCryptoWallet: '',
    textAddCryptoWallet: '',
    locale: '',
    errorMessage: '',
    labelTitleSend: '',
    labelHistory: '',
    selectPaymentOffers: '',
    waitingText: '',
    backButton: '',
    waitingTitle: '',
    nameTransactionId: '',
    paymentNameCard: '',
    paymentNameDetails: '',
    paymentDetailsAmountName: '',
    paymentDetailsAmountNameTo: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadBuyCryptoModal() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('buy-crypto-modal')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
